module.exports = __webpack_public_path__ + "media/bilibili-winter-view-3.79f65a9c.79f65a9c.webm";